import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { NewsfeedPage } from './newsfeed.page';
import { PagesModule } from '../pages.module';

const routes: Routes = [
  {
    path: '',
    component: NewsfeedPage
  }
];

@NgModule({
  imports: [
    PagesModule,
    RouterModule.forChild(routes)
  ],
  declarations: [NewsfeedPage]
})
export class NewsfeedPageModule { }
